module.exports = __webpack_public_path__ + "img/dab_orzech.8e6f5f05.jpg";